import React from 'react'
import { axiosWithKey } from '~/axios'
import { get, map, pickBy } from 'lodash'
import { getToken } from '~/redux/user/tokens'
import viewliftLogo from '~/assets/images/viewlift-logo.png'
import './Footer02.css'

import appStore from '~/assets/images/app-store-badge.svg'
import playStore from '~/assets/images/google-play-badge.png'
import { localizeTitle } from '~/tools/localization';

// HACK:
// Shraddha said to just do it for the hoichoi launch,
//  Once Chandra fixes the video api to take a flag to show or hide trailers, we will change it back
const __curated__films__ = [
  // Haami
  "40b3114f-49e9-48b9-bf32-70427d3e5399",
  //  Hercules
  "91c39ddb-2b85-441a-a209-bedb475bc1cd",
  // Hemanta
  "e5e94486-e05f-47e7-b81e-c14ed1f51c36",
  // Bastu Shaap
  "6005b5aa-7531-4bd4-9883-7dc7ed64cde7",
  // Katmundu
  "6ed5ba16-a689-435f-bf7d-a572a5251d56"
];
const getBadgeSrc = url =>
  url.includes('apple.com') ? appStore : url.includes('google.com') ? playStore : ''

class Footer02 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      latestVideos: [],
    }
  }

  componentDidMount() {
    getToken().then(authorization =>
      axiosWithKey.get('/content/videos', {
        headers: {
          authorization
        },
        params: {
          ids: __curated__films__.join(','),
        }
      }).then(({ data }) => {
        this.setState({
          latestVideos: data.records
        })
      })
    )
  }

  render() {
    const primaryLinks = get(window.settings, 'navigation.footer')
    const appStoreLinks = get(window.settings, 'navigation.appStore')
    const socialLinks = pickBy(get(window.settings, 'socialMedia'), link => link.url)

    return (
      <div className="footer02">
        <div className="footer02__content footer">
          <div className="footer02__left">
            <img
              className="footer02__logo"
              src={get(window.settings, 'images.desktopLogo')}
              alt={window.settings.site}
            />
            {/* <p className="footer02__description">TODO: pull description from somewhere</p> */}
            <p className="footer02__copyright">
              {`Copyright ${new Date().getFullYear()} ${window.settings
                .companyName}. All rights reserved.`}
            </p>
          </div>

          <div className="footer02__center">
            <div className="footer02__links">
              <h4 className="footer02__links-heading">Learn More</h4>
              {map(primaryLinks, (l, i) => (
                <a className="footer02__link link" href={l.url} target={l.newTab ? "_blank" : "_self"} key={i}>
                  {localizeTitle(l)}
                </a>
              ))}
            </div>
            <div className="footer02__links">
              <h4 className="footer02__links-heading">Latest Movies</h4>
              {map(this.state.latestVideos, ({ gist }) => (
                <a className="footer02__link link" href={gist.permalink} key={gist.id}>
                  {gist.title}
                </a>
              ))}
            </div>
          </div>

          <div className="footer02__right">
            <div className="footer02__appstore-links">
              {map(appStoreLinks, ({ displayedPath, title }, i) => (
                <a className="footer02__appstore-link" href={displayedPath} key={i}>
                  { !window.SERVER_SIDE_RENDERING && (
                    <img
                      className="footer02__appstore-image"
                      src={getBadgeSrc(displayedPath)}
                      alt={title}
                      title={title}
                    />
                  ) }
                </a>
              ))}
            </div>
            <div className="footer02__social-links">
              {map(socialLinks, (sl, k) => (
                <a key={k} href={sl.url} target="_blank" rel="noopener noreferrer" className={`footer02__social-link ${k}`}>
                  <span className={`ion-social-${k}`} />
                </a>
              ))}
            </div>
            <p className="powered-by">
              Powered by
              <a target="_blank" rel="noopener noreferrer" href="http://www.viewlift.com/">
                {!window.SERVER_SIDE_RENDERING && <img src={viewliftLogo} alt="ViewLift" />}
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer02
